(function() {
    "use strict";

    angular.module("eSign")
      .controller("LoginController", ['$scope', '$window', '$http', '$rootScope', '$sce', 'validationService', 'sessionService', 'appConfig', function($scope, $window, $http, $rootScope, $sce, validationService, sessionService, appConfig) {

        $scope.configSettings = "";
		
		var gotoIFrame = function () {
			$scope.iframeUrl = appConfig.iframeLoginUrl + '?ssn=' + $scope.ssn;
			$scope.displayIframe = true;
		  }

        $scope.submitForm = function() {
	        gotoIFrame();
        };

        $scope.submitMobileForm = function () {
            $scope.iframeUrl = appConfig.iframeLoginMobileUrl + '?mobile=' + $scope.mobile + '&birthdate=' + $scope.birthdate;
            $scope.displayIframe = true;
        };

        $scope.redirectToUrl = function(url) {
            $window.location.href = url;
        };

          $scope.validatessn = function (ssn) {
              if ($scope.configSettings.countryCode === "FI") {
                  return validationService.validateSSN_FI(ssn);
              }
            return validationService.validateSSN(ssn);
        };

        $scope.validateinput = function (mobile, birthdate) {
            return isNumeric(birthdate) && birthdate.length === 6
                && isNumeric(mobile) && mobile.length === 8;
        };

        function isNumeric(number) {
            return !isNaN(number);
		  }

		  
          var getConfigSettings = function () {
              sessionService.getSettings().then(function(response) {
				  $scope.configSettings = response.data;
	              if ($scope.configSettings.countryCode === "FI") {
		              gotoIFrame();
	              }
              });
            }; 
        
        getConfigSettings();

        }]);
}());
